import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "@react-navigation/native";
import * as React from "react";
import { Animated, Easing, Platform, Pressable } from "react-native";
var AnimatedPressable = Animated.createAnimatedComponent(Pressable);
var ANDROID_VERSION_LOLLIPOP = 21;
var ANDROID_SUPPORTS_RIPPLE = Platform.OS === "android" && Platform.Version >= ANDROID_VERSION_LOLLIPOP;
/**
 * PlatformPressable provides an abstraction on top of Pressable to handle platform differences.
 */ export default function PlatformPressable(_param) {
    var onPressIn = _param.onPressIn, onPressOut = _param.onPressOut, android_ripple = _param.android_ripple, pressColor = _param.pressColor, _param_pressOpacity = _param.pressOpacity, pressOpacity = _param_pressOpacity === void 0 ? 0.3 : _param_pressOpacity, style = _param.style, rest = _object_without_properties(_param, [
        "onPressIn",
        "onPressOut",
        "android_ripple",
        "pressColor",
        "pressOpacity",
        "style"
    ]);
    var dark = useTheme().dark;
    var _React_useState = _sliced_to_array(React.useState(function() {
        return new Animated.Value(1);
    }), 1), opacity = _React_useState[0];
    var animateTo = function(toValue, duration) {
        if (ANDROID_SUPPORTS_RIPPLE) {
            return;
        }
        Animated.timing(opacity, {
            toValue: toValue,
            duration: duration,
            easing: Easing.inOut(Easing.quad),
            useNativeDriver: true
        }).start();
    };
    var handlePressIn = function(e) {
        animateTo(pressOpacity, 0);
        onPressIn === null || onPressIn === void 0 ? void 0 : onPressIn(e);
    };
    var handlePressOut = function(e) {
        animateTo(1, 200);
        onPressOut === null || onPressOut === void 0 ? void 0 : onPressOut(e);
    };
    return /*#__PURE__*/ _jsx(AnimatedPressable, _object_spread({
        onPressIn: handlePressIn,
        onPressOut: handlePressOut,
        android_ripple: ANDROID_SUPPORTS_RIPPLE ? _object_spread({
            color: pressColor !== undefined ? pressColor : dark ? "rgba(255, 255, 255, .32)" : "rgba(0, 0, 0, .32)"
        }, android_ripple) : undefined,
        style: [
            {
                opacity: !ANDROID_SUPPORTS_RIPPLE ? opacity : 1
            },
            style
        ]
    }, rest));
}
